export const SESSION_OVERRIDE_KEY = "golf-app-session-unit-override";
